export const ross1000 = {
  title: "ROSS 1000 / Turismo5",
  subtitle: "Tourist flow statistics — regional reporting",

  fields: {
    region: "Region",
    codice: "Structure code",
    codiceHint: "Structure code assigned by the region (the «codice» field).",
    username: "Username",
    password: "Password",
    passwordHint: "ROSS 1000 web service credentials (issued by the region / GIES).",
    prodotto: "Software name",
    camereDisponibili: "Available rooms",
    lettiDisponibili: "Available beds",
    defaultTipoturismo: "Tourism type (default)",
    defaultMezzotrasporto: "Means of transport (default)",
    useTestEndpoint: "Use test environment",
    endpointResolved: "Endpoint",
    keepBlank: "(leave blank to keep current)",
  },

  regionOptions: {
    sardegna: "Sardinia",
    lazio: "Lazio",
    veneto: "Veneto",
    emilia_romagna: "Emilia-Romagna",
    toscana: "Tuscany",
    piemonte: "Piedmont",
    lombardia: "Lombardy",
    liguria: "Liguria",
    marche: "Marche",
    abruzzo: "Abruzzo",
    molise: "Molise",
    calabria: "Calabria",
    basilicata: "Basilicata",
  },

  actions: {
    saveAndVerify: "Save & verify",
    updateCredentials: "Update credentials",
    verifyConnection: "Verify connection",
    saving: "Saving...",
    verifying: "Verifying...",
  },

  status: {
    connectionOk: "Credentials saved and connection verified successfully.",
    connectionError: "Connection error. Check the credentials entered.",
    connectionPending: "Connection not yet verified. Click «Verify connection» to confirm.",
  },

  validation: {
    codiceRequired: "The structure code is required.",
    usernameRequired: "The username is required.",
    passwordRequired: "The password is required.",
    capacityRequired: "Enter the available rooms and beds.",
  },

  toasts: {
    saveSuccess: "Credentials saved and connection verified successfully.",
    saveWarning: "Credentials saved, but the connection could not be verified.",
    saveError: "Could not save the credentials.",
    testSuccess: "ROSS 1000 connection verified successfully.",
    testError: "Could not verify the connection.",
    statusActive: "ROSS 1000 enabled.",
    statusInactive: "ROSS 1000 disabled.",
  },
};
